<template lang="pug">
v-container(fluid px-0 fill-height class=" tw-items-start tw-content-start tw-overflow-x-hidden tw-bg-blueGray-lighten-5")
  kubiqa-website-themes-theme-b-components-shared-top-navigation
  v-row(justify="center" class=" tw-bg-blueGray-darken-2 tw-border tw-border-gray-lighten-2")
    v-col(cols="auto" class="tw-w-auto tw-m-0 tw-p-0 ")
      v-container(class=" tw-w-auto tw-p-0 tw-m-0 tw-mx-auto")
        v-row(no-gutters)
          v-col(class="")
            div(class="tw-z-0 tw-relative")
              v-carousel(hide-delimiters height="auto" width="auto")
                v-carousel-item(v-for="(photo, i) in photos" :key="i" :src="photo.src")
  v-row(no-gutters justify="center" class="tw--mt-16 d-flex tw-relative tw-z-10")
    v-col(cols="7" class="tw-bg-white tw-rounded ")
      v-container(class="tw-px-8 tw-py-8")
        v-row
          v-col(cols="auto")
            div(class="tw-bg-green-lighten-5 tw-rounded-full tw-px-3  tw-py-1")
              span(class="tw-text-green-darken-2 tw-text-sm") For {{ this.$faker().random.arrayElement(['Rent', 'Sale']) }}
        v-row
          v-col(cols="stretch")
            span(class="tw-text-xl tw-font-bold") {{ this.$faker().lorem.sentence(6) }}
          v-col(cols="auto")
            span(class=" font-weight-bold  tw-text-4xl tw-text-teal-accent-4") ${{ this.$faker().finance.amount(10000, 100000, 0) }}
        v-row(no-gutters align="center" justify="start" class="tw-pt-2 tw--ml-1")
          v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
            div(class="tw-w-6 tw-h-6 tw-flex ")
              v-icon(color=" blue-grey lighten-2" class="tw-mx-auto") mdi-map-marker-outline
          v-col(cols="auto" class=" tw-text-center")
            span(class="tw-ml-1 text-secondary") {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}

        v-row(dense justify="start" class="tw-py-2 tw-pt-3")
          v-col(cols="auto" class="tw-mr-2")
            v-row(no-gutters align="center" justify="center")
              v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                div(class="tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-flex ")
                  v-icon(small color=" blue-grey lighten-2" class="tw-mx-auto") mdi-bed-king
              v-col(cols="auto" class=" tw-text-center")
                span(class="tw-ml-1 text-secondary tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Beds

          v-col(cols="auto" class="tw-mr-2")
            v-row(no-gutters align="center" justify="center")
              v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                div(class="tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-flex ")
                  v-icon(small color=" blue-grey lighten-2" class="tw-mx-auto") mdi-shower
              v-col(cols="auto" class=" tw-text-center")
                span(class="tw-ml-1 text-secondary tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Bath

          v-col(cols="auto" class="tw-mr-2")
            v-row(no-gutters align="center" justify="center")
              v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                div(class="tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-flex ")
                  v-icon(small color=" blue-grey lighten-2" class="tw-mx-auto") mdi-arrow-all
              v-col(cols="auto" class=" tw-text-center")
                span(class="tw-ml-1 text-secondary tw-text-sm") {{ this.$faker().datatype.number({ min: 200, max: 800 }) }} m <sup>2</sup>

  v-row(justify="space-around" class="tw-pt-8 ")
    v-col(cols="10")
      v-row
        v-col(cols="" class="")
          v-container(fluid p-0 class=" tw-bg-white tw-rounded")
            v-row
              v-col(class="")
                span(class="tw-text-xl tw-font-bold") Description
            v-row
              v-col
                p
                  span {{ this.$faker().lorem.paragraphs(2) }}
                p
                  span {{ this.$faker().lorem.paragraphs(3) }}
          div(class="tw-py-4") 
          v-container(fluid p-0 class=" tw-bg-white tw-rounded")
            v-row
              v-col(class="")
                span(class="tw-text-xl tw-font-bold") Detail
            v-row
              v-col
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds

              v-col
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
              v-col
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
          div(class="tw-py-4")
          v-container(fluid p-0 class=" tw-bg-white tw-rounded")
            v-row
              v-col(class="")
                span(class="tw-text-xl tw-font-bold") Amenities
            v-row
              v-col
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-lightGreen-lighten-4 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" light-green darken-1" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-lightGreen-lighten-4 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" light-green darken-1" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-lightGreen-lighten-4 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" light-green darken-1" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              v-col
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-lightGreen-lighten-4 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" light-green darken-1" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-lightGreen-lighten-4 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" light-green darken-1" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-lightGreen-lighten-4 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" light-green darken-1" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              v-col
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-lightGreen-lighten-4 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" light-green darken-1" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-lightGreen-lighten-4 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" light-green darken-1" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-lightGreen-lighten-4 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" light-green darken-1" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
          div(class="tw-py-4")
          v-container(fluid p-0 class=" tw-bg-white tw-rounded")
            v-row
              v-col(class="")
                span(class="tw-text-xl tw-font-bold") Location
            v-row
              v-col
                kubiqa-misc-map

        v-col(cols="4")
          v-container(class="tw-bg-white tw-rounded tw-overflow-hidden")
            v-row(align="center" class="tw-bg-teal-lighten-2  tw-h-16")
              v-col(class=" ")
                span(class="tw-text-white tw-font-bold tw-text-xl") Contact
            v-row
              v-col(class="tw-bg-white")
                v-row
                  v-col
                    v-text-field(label="Your name" filled)
                    v-text-field(label="Your phone" filled)
                    v-text-field(label="Your email" filled)
                    v-textarea(
                      height="220"
                      filled
                      hide-details
                      placeholder="I'm interested in this property. Please send me additional information."
                    )
                    v-btn(
                      x-large
                      @click="method"
                      block
                      color="teal lighten-2"
                      elevation="0"
                      class="tw-mt-6"
                    ) 
                      |
                      span(class="tw-font-bold") Send
  v-row(class="tw-pt-24")
    v-col

  kubiqa-website-themes-theme-b-components-shared-footer
</template>

<script>
export default {
  data() {
    return {
      photos: [],
    };
  },
  updated() {
    this.fakePhotos();
  },
  created() {
    this.fakePhotos();
  },
  methods: {
    fakePhotos() {
      this.photos = [];
      for (let index = 0; index < 20; index++) {
        this.photos.push({
          src: this.sampleWebsiteImage('listing', 2048, 600, index),
        });
      }
    },
  },
};
</script>

<style scoped>
.v-carousel >>> .v-btn {
  margin: 0px;
}
</style>
